module.exports = __webpack_public_path__ + "a221b17810c09f8f4b784e8433ce8d63.png";